import axios from 'axios';
import {
  GET_STATIC_SCREEN_REQUEST,
  GET_STATIC_SCREEN_SUCCESS,
  GET_STATIC_SCREEN_FAILURE,

  GET_STATIC_CONTENT_SCREEN_REQUEST,
  GET_STATIC_CONTENT_SCREEN_SUCCESS,
  GET_STATIC_CONTENT_SCREEN_FAILURE,
} from 'Store/constants';
import errorMessage from 'Store/actions/errorMessage';
import ProjectConfig from 'ProjectConfig';
const API_GATEWAY = ProjectConfig.API_GATEWAY;


export const getStaticScreen = () => async dispatch => {
  try {

    dispatch({
      type: GET_STATIC_SCREEN_REQUEST
    });

    const res = await axios.get(API_GATEWAY + '/cms/staticScreen/names/MW');

    dispatch({
      type: GET_STATIC_SCREEN_SUCCESS,
      payload: res.data?.data
    });

  } catch (e) {

    dispatch({
      type: GET_STATIC_SCREEN_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

export const getStaticContent = path => async dispatch => {
  try {
    dispatch({
      type: GET_STATIC_CONTENT_SCREEN_REQUEST
    });

    const res = await axios.get(API_GATEWAY + '/cms/staticScreen/screens/MW/' + path );

    dispatch({
      type: GET_STATIC_CONTENT_SCREEN_SUCCESS,
      payload: res.data
    });

  } catch (e) {

    dispatch({
      type: GET_STATIC_CONTENT_SCREEN_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};